import keys from 'lodash/keys';
import { GhostButton, PrimaryButton, SecondaryButton } from 'ui/button';
import { ModalFooter } from 'ui/modal';
import { ActionButtonContainer, ModalActionsContainer } from './CatalogForm.styled';

// type clickableProps = {
//   isDisabled: ?boolean,
//   onClick: (*) => void,
//   text: string,
// };
const renderGhostButton = ({ isDisabled, onClick, text }) => (
  <GhostButton data-test="ghost-button" onClick={onClick} isDisabled={isDisabled}>
    {text}
  </GhostButton>
);

// type buttonProps = {
//   appearance: string,
//   onClick: (*) => void,
//   text: string,
//   isDisabled: ?boolean,
// };
const renderButton = ({ appearance, onClick, text, isDisabled }) =>
  appearance === 'success' ? (
    <PrimaryButton
      data-test="catalog-form-primary-action-button"
      onClick={onClick}
      disabled={isDisabled || false}
    >
      {text}
    </PrimaryButton>
  ) : (
    <SecondaryButton
      data-test="catalog-form-secondary-action-button"
      onClick={onClick}
      disabled={isDisabled || false}
    >
      {text}
    </SecondaryButton>
  );

export const getNumberNewDefinedFields = (fields) => keys(fields).length;

// type Props = {
//   isCatalogCollectionsFlagOn: boolean,
//   isDisabled: boolean,
//   handleStepAndSkip: (*) => void,
//   handleSubmitToCatalog: (*) => void,
//   handleSubmit: (*) => void,
//   step: number,
//   skipDefine: boolean,
//   fields: Object,
//   hasNewFields: boolean,
//   nestedFieldsWarning: boolean,
// };
const ModalActions = (props) => {
  const {
    step,
    skipDefine,
    handleStepAndSkip,
    handleSubmitToCatalog,
    handleSubmit,
    isDisabled,
    hasNewFields,
    fields,
    nestedFieldsWarning,
  } = props;

  const renderStep3 = () => (
    <ActionButtonContainer>
      {renderGhostButton({
        onClick: () =>
          skipDefine ? handleStepAndSkip(1, skipDefine) : handleStepAndSkip(2, skipDefine),
        text: 'Go back',
      })}
      {renderButton({
        appearance: 'success',
        onClick: handleSubmit,
        text: 'Confirm and upload',
        isDisabled,
      })}
    </ActionButtonContainer>
  );

  const renderActions = () => {
    switch (step) {
      case 1:
        /* check to see if there are new fields that need defining */
        return (
          <ActionButtonContainer>
            {hasNewFields && !nestedFieldsWarning
              ? renderButton({
                  appearance: 'default',
                  onClick: () => handleStepAndSkip(2, false),
                  isDisabled,
                  text: 'Define field types',
                })
              : renderButton({
                  appearance: 'success',
                  onClick: handleSubmit,
                  isDisabled,
                  text: 'Create',
                })}
          </ActionButtonContainer>
        );
      case 2:
        // check to see if skipping step
        if (skipDefine) {
          return (
            <>
              {renderGhostButton({
                onClick: () => handleStepAndSkip(2, false),
                text: 'No, define field types now',
              })}
              {renderButton({
                appearance: 'success',
                onClick: handleSubmitToCatalog,
                isDisabled,
                text: 'Yes, upload to catalog only',
              })}
            </>
          );
        }
        return (
          <>
            <div>
              Changes will be made to <strong>{getNumberNewDefinedFields(fields)} fields</strong> in
              this catalog
            </div>
            <ActionButtonContainer>
              {renderGhostButton({
                onClick: () => handleStepAndSkip(3, true),
                text: 'Skip for now',
              })}
              {renderButton({
                appearance: 'default',
                onClick: () => handleStepAndSkip(3, false),
                text: 'Review these changes',
              })}
            </ActionButtonContainer>
          </>
        );
      case 3:
        if (skipDefine) {
          return renderStep3();
        }
        return (
          <>
            <div>
              <strong>Be careful!</strong> Once confirmed, field types cannot be redefined
            </div>
            <ActionButtonContainer>{renderStep3()}</ActionButtonContainer>
          </>
        );
      default:
        return <div />;
    }
  };

  return (
    <ModalFooter hasCancel={false}>
      <ModalActionsContainer>
        {props.isCatalogCollectionsFlagOn
          ? renderActions({ ...props })
          : renderButton({
              appearance: 'success',
              onClick: handleSubmit,
              text: 'Create',
              isDisabled,
            })}
      </ModalActionsContainer>
    </ModalFooter>
  );
};

export default ModalActions;
ModalActions.defaultProps = {
  fields: {},
};
